import { Link } from 'react-router-dom';
import { Sparkles, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { label: 'Sobre Nosotros', href: '/about' },
      { label: 'Contacto', href: '/contact' },
      { label: 'Blog', href: '/blog' },
    ],
    legal: [
      { label: 'Términos y Condiciones', href: '/terms' },
      { label: 'Política de Privacidad', href: '/privacy' },
      { label: 'Política de Cookies', href: '/cookies' },
    ],
    services: [
      { label: 'Para Clientes', href: '/services/clients' },
      { label: 'Para Profesionales', href: '/services/professionals' },
      { label: 'Preguntas Frecuentes', href: '/faq' },
    ],
  };

  const socialLinks = [
    { icon: Facebook, href: 'https://facebook.com', label: 'Facebook' },
    { icon: Twitter, href: 'https://twitter.com', label: 'Twitter' },
    { icon: Instagram, href: 'https://instagram.com', label: 'Instagram' },
    { icon: Linkedin, href: 'https://linkedin.com', label: 'LinkedIn' },
  ];

  return (
    <footer className="border-t border-neutral-800 bg-neutral-900">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <Sparkles className="h-6 w-6 text-luxury-gold" />
              <span className="text-xl font-bold">
                <span className="text-[#B8860B]">Beauty</span>
                <span className="text-[#D4AF37]">Book</span>
                <span className="text-[#B8860B]">AI</span>
              </span>
            </Link>
            <p className="text-sm text-neutral-300">
              Tu plataforma de confianza para reservar servicios de belleza y bienestar.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="h-10 w-10 rounded-full bg-neutral-800 hover:bg-neutral-700 text-luxury-pearl hover:text-luxury-gold flex items-center justify-center transition-colors"
                  aria-label={social.label}
                >
                  <social.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="font-semibold mb-4 text-luxury-pearl">Empresa</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-neutral-300 hover:text-luxury-gold transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h3 className="font-semibold mb-4 text-luxury-pearl">Servicios</h3>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-neutral-300 hover:text-luxury-gold transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="font-semibold mb-4 text-luxury-pearl">Legal</h3>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-neutral-300 hover:text-luxury-gold transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-neutral-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-neutral-300">
              © {currentYear} BeautyBookAI. Todos los derechos reservados. Un producto de{' '}
              <a href="https://axxionai.com" target="_blank" rel="noopener noreferrer" className="text-luxury-gold hover:underline">
                AxxionAI
              </a>
            </p>
            <p className="text-sm text-neutral-300">
              Hecho con{' '}
              <span className="text-luxury-gold">❤</span>{' '}
              para amantes de la belleza
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
